import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { endpoints } from '../_config/endpoint';

@Injectable({
  providedIn: 'root'
})
export class LearningPathService {
  constructor(private http: HttpClient) {}

  createLearningPath(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.createLearningPath}`,
      payload
    );
  }

  getLearningPath(id) {
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getOneLearingPath}/${id}`
    );
  }

  getAllLearningPaths(page, size) {
    const params = new HttpParams().set('page', page).set('size', size);
    return this.http.get(
      `${environment.API_URL_V1}/${endpoints.getAllLearningPaths}`,
      { params }
    );
  }
  updateLearningPath(payload) {
    return this.http.put(
      `${environment.API_URL_V1}/${endpoints.updateLearningPath}/${payload.id}/update`,
      payload
    );
  }
  deleteLearningPath(id) {
    return this.http.delete(
      `${environment.API_URL_V1}/${endpoints.updateLearningPath}/${id}/delete`
    );
  }

  assignLpToStaffs(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignLpToIndividual}`,
      payload
    );
  }
  assignLpToDepartments(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignLpToDepartment}`,
      payload
    );
  }
  assignLpToDivisions(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignLpToDivision}`,
      payload
    );
  }
  assignLpToUnits(payload) {
    return this.http.post(
      `${environment.API_URL_V1}/${endpoints.assignLpToUnit}`,
      payload
    );
  }
}
